export default __webpack_public_path__ + "static/media/2.9f8de800.jpg";